import { Input } from '@/components/Input';
import {
    ESellerType,
    selectSellerEmail,
    selectSellerType,
    setSellerEmail,
} from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'DealershipEmail';

export function DealershipEmail({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectSellerEmail);
    const dispatch = useAppDispatch();
    const sellerType = useAppSelector(selectSellerType);

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        if (typeof value === 'boolean') return;
        if (value === currentState) return;
        if (value?.length > 100) return;
        dispatch(setSellerEmail(value));
    }

    function getTitleName(): string {
        const string = ' Email';
        const title =
            sellerType === ESellerType.DEALERSHIP ? 'Dealership' : 'Seller';

        return title + string;
    }

    // ***** Render *****
    return (
        <div data-testid={testId}>
            <Input
                title={getTitleName()}
                placeholder='Optional'
                showErrors={showErrors}
                onChange={handleChange}
                id={`${baseId}-input-dealershipEmail`}
                value={currentState?.toLocaleString() ?? ''}
                disabled={false}
            />
        </div>
    );
}
